import styled, { css } from 'styled-components'

type WrapperProps = {
  offsetHeight?: number
  fullScreen?: boolean
}
export const Wrapper = styled.div<WrapperProps>`
  ${({ offsetHeight, fullScreen, theme }) => css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    ${offsetHeight !== undefined
      ? css`
          width: 100%;
          height: calc(100vh - ${offsetHeight}px);
        `
      : css`
          width: auto;
          height: auto;
        `}
    ${fullScreen &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: ${theme.background.primary};
      z-index: 9999;
    `}
  `}
`
